module.exports = __webpack_public_path__ + "img/bg-profile.6c46ca4d.png";